import styled from 'styled-components';

const Container = styled.div`
  ${({ theme }) => theme.fontFamily.mainFont.smallExtraBold}

  height: 56px;
  line-height: 56px;
  background: ${({ theme }) => theme.colors.corporateWhite};
  z-index: ${({ theme }) => theme.constants.zIndex.fixedHeader};
  overflow: hidden;
`;

export default Container;
